import classNames from "classnames";

import { roundAndDropTrailingZeros } from "@ascendnow/shared";

import styles from "./AscRankPodium.module.scss";
import AscAvatar from "../AscAvatar/AscAvatar";
import {
  LargeRankFirstPlaceDecoration,
  PodiumFirstPlaceBackground,
  PodiumSecondPlaceBackground,
  PodiumThirdPlaceBackground,
} from "../AscIllustrations";
import AscTag from "../AscTag/AscTag";
import { AscRankItemI } from "../AscRankItem/AscRankItem.type";

function AscRankPodium({ podium }: { podium: AscRankItemI[] }) {
  const getPointsTag = (points: number, rank: number) => {
    const pointsSuffix =
      points != null && Math.floor(points) !== 1 ? " points" : " point";

    const label = (
      <span className={styles.pointsLabel}>
        {roundAndDropTrailingZeros(Number(points))} {pointsSuffix}
      </span>
    );
    switch (rank) {
      case 1:
        return (
          <AscTag
            className={styles.pointsTag}
            type={"points-first-place"}
            label={label}
          />
        );
      case 2:
        return (
          <AscTag
            className={styles.pointsTag}
            type={"points-second-place"}
            label={label}
          />
        );
      case 3:
        return (
          <AscTag
            className={styles.pointsTag}
            type={"points-third-place"}
            label={label}
          />
        );
      default:
        return null;
    }
  };

  const getBackground = (rank: number) => {
    switch (rank) {
      case 1:
        return (
          <PodiumFirstPlaceBackground
            className={styles.background}
            data-testid={"test-background"}
          />
        );
      case 2:
        return (
          <PodiumSecondPlaceBackground
            className={styles.background}
            data-testid={"test-background"}
          />
        );
      case 3:
        return (
          <PodiumThirdPlaceBackground
            className={styles.background}
            data-testid={"test-background"}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.element}>
      <div className={styles.wrapper}>
        {podium.map((item, index) => (
          <div
            key={index + item.name}
            className={classNames(styles.podiumItem, {
              [styles.first]: item.rank === 1,
              [styles.second]: item.rank === 2,
              [styles.third]: item.rank === 3,
            })}
          >
            <div className={styles.podiumItemInner}>
              <div className={styles.avatarWrapper}>
                <AscAvatar
                  className={styles.avatar}
                  src={item.avatarUrl}
                  flag={item?.flag}
                />
                <div className={styles.rank}>{item.rank}</div>
                {item.rank === 1 && (
                  <LargeRankFirstPlaceDecoration
                    className={styles.firstPlaceDecoration}
                    data-testid={"test-decor-first"}
                  />
                )}
              </div>
              <div className={styles.name}>
                {item.name}
                <div
                  className={classNames(styles.rankTag, {
                    [styles.gold]: item.rank === 1,
                    [styles.silver]: item.rank === 2,
                    [styles.bronze]: item.rank === 3,
                  })}
                  data-testid={"test-tag"}
                />
              </div>
              {getPointsTag(item.points as number, item.rank)}
            </div>
            {getBackground(item.rank)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default AscRankPodium;
